export default __webpack_public_path__ + "images/57520051e8b04b5da9e36b58aced48fd.png";